export const OtherDailyParamsLabels = {
  dailyEnergyConstraint: "Energy Constraint"
};
